import { render, staticRenderFns } from "./GroupMenu.vue?vue&type=template&id=3b1a019c&scoped=true&"
import script from "./GroupMenu.vue?vue&type=script&lang=js&"
export * from "./GroupMenu.vue?vue&type=script&lang=js&"
import style0 from "./GroupMenu.vue?vue&type=style&index=0&id=3b1a019c&lang=scss&scoped=true&"
import style1 from "./GroupMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a019c",
  null
  
)

export default component.exports